import { useEffect } from "react";
import { Outlet, useSearchParams } from "react-router";

// http://localhost:5173/?holderCommitment=16607625577278438594767804415218927671757671726577118445895787921662140036661&encryptionPubKey=gkUeDzcB1eGHlTzX8V%2Bh8kwo28d8h799SUAhsaLuFyA%3D

export const HolderCommitmentGuard = () => {
  const [searchParams] = useSearchParams();
  const holderCommitmentParam = searchParams.get("holderCommitment");
  const encryptionPubKeyParam = searchParams.get("encryptionPubKey");
  const from = searchParams.get("from");

  const savedHolderCommitment = sessionStorage.getItem("holderCommitment");
  const savedEncryptionPubKey = sessionStorage.getItem("encryptionPubKey");
  const savedFrom = sessionStorage.getItem("from");

  useEffect(() => {
    if (!holderCommitmentParam || !encryptionPubKeyParam || !from) return;

    sessionStorage.setItem("holderCommitment", holderCommitmentParam);
    sessionStorage.setItem("encryptionPubKey", encryptionPubKeyParam);
    sessionStorage.setItem("from", from);
  }, [holderCommitmentParam, encryptionPubKeyParam, from]);

  const resultHolderCommitment = savedHolderCommitment || holderCommitmentParam;
  const resultHolderEncryptionPubKey =
    savedEncryptionPubKey || encryptionPubKeyParam;
  const resultForm = savedFrom || from;

  if (
    import.meta.env.PROD &&
    (!resultHolderCommitment || !resultHolderEncryptionPubKey)
  ) {
    sessionStorage.setItem("noHolderCommitment", "true");
  } else {
    sessionStorage.setItem("noHolderCommitment", "false");
  }

  return (
    <Outlet
      context={{
        // TODO: remove hardcoded values before release
        holderCommitment:
          resultHolderCommitment ??
          "16607625577278438594767804415218927671757671726577118445895787921662140036661",
        encryptionPubKey:
          resultHolderEncryptionPubKey ??
          "gkUeDzcB1eGHlTzX8V%2Bh8kwo28d8h799SUAhsaLuFyA%3D",
        from: resultForm || "https://app.galactica.com/my-certificates",
      }}
    />
  );
};
